import React from 'react'

export default function DropdownWrapper({ options, ...props }) {
  return <select {...props}>
    {(options || []).map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
  </select>
}
